/**
 * External dependencies
 */
import React, { useEffect } from 'react';
import { connect } from 'react-redux';

/**
 * Internal dependencies
 */

import { requestCurrentRoamIfNotRequested } from 'state/current-roam/actions';
import { getCurrentRoam, requestingCurrentRoam } from 'state/current-roam/selectors';
import RoamPlanLoader from './roam-plan-loader';
import Icon from 'components/icon';
import Money from 'components/money';
import PlanName from 'components/plan-name';
import DateTime from 'components/date-time';
import Coupon from 'components/coupon';
import { Stack, Box, Divider, Text } from '@towersystems/towersystems-design-system';
import DetailListItem from 'components/detail-list-item';
import SubscriptionStatus from 'components/subscription-status';
import Card from 'components/card';


/**
 * Style dependencies
 */
import './styles.scss';

const CurrentRoamPlanCard = (props) => {
	let currentRoam= props.currentRoam;

	useEffect(() => {
		props.requestCurrentRoam();
	}, []);

	if (!currentRoam && !props.requesting) {
		return (
			<Card>
				<Card.Header heading='Plan details' />
				<Stack>
					<Card.Section>
						<DetailListItem label='Plan amount' />
					</Card.Section>
					<Card.Section>
						<DetailListItem label='Current billing period' />
					</Card.Section>
					<Card.Section>
						<DetailListItem label='Next billing date' />
					</Card.Section>
				</Stack>
			</Card>
		);
	}

	if (!currentRoam && props.requesting) {
		return <RoamPlanLoader />;
	}

	return (
		<Stack space='xxlarge'>
				
		    {currentRoam.map((roam) => {
		    	return (<Card><Stack><Card.Section>
							<Box display='flex' padding='small' alignItems='center'>
								<Stack space='small'>
									<Box>
										<PlanName value={roam.subscription.plan_id} />
									</Box>
									<Box>
									    Price:
										<Money value={roam.subscription.plan_unit_price / 100} /> /{' '}
										{roam.subscription.billing_period} {roam.subscription.billing_period_unit}
						         	</Box>
						         	{roam.subscription.status == 'active' && (
						         	<Box>
									    Next Billing On <DateTime date={roam.subscription.next_billing_at} />
						         	</Box>
						         	)}

						         	{roam.subscription.addons && (
										<Box padding='small'>
											<Box marginBottom='medium'>
												<Text weight='medium' size='small'>
													Addons
												</Text>
											</Box>
											<Stack space='medium' dividers>
												{roam.subscription.addons.map(({ unit_price, quantity, amount, id }) => {
													return (
														<Box
															key={id}
															display='flex'
															alignItems='center'
															justifyContent='spaceBetween'
														>
															<Text size='small' padding='small'>
															    {id} {' '}
																<Money value={amount / 100} /> ( x {quantity})
															</Text>
														</Box>
													);
												})}
											</Stack>
										</Box>
								
								    )}

								    {roam.subscription.coupons && (
										<Box padding='small'>
											<Box marginBottom='medium'>
												<Text weight='medium' size='small'>
													Discounts
												</Text>
											</Box>
											<Stack space='medium' dividers>
												{roam.subscription.coupons.map(({ coupon_id }) => {
													return (
														<Box key={coupon_id}>
															<Coupon couponId={coupon_id}></Coupon>
														</Box>
													);
												})}
											</Stack>
										</Box>
									)}
									<Box>
										<SubscriptionStatus status={roam.subscription.status} />
									</Box>
									{roam.subscription.status == 'future' && (
									<Box>
										Subscription start date: 
										{<DateTime date={roam.subscription.start_date} format='Do MMM, YYYY' />}
						         	</Box>
						         	)}
						         	
								</Stack>
							</Box>
							
						</Card.Section></Stack></Card>)
		    })}
			
		</Stack>
	);
};

export default connect(
	(state) => ({
		currentRoam: getCurrentRoam(state),
		requesting: requestingCurrentRoam(state),
	}),
	{
		requestCurrentRoam: requestCurrentRoamIfNotRequested,
	},
)(CurrentRoamPlanCard);
